module.exports = __webpack_public_path__ + "static/lighthousesunset@fiferries.4d94f4c5.jpg";